'use client'

import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'

import { useBooking } from '../../model/bookingContext'
import { BookingStepEnum } from '../../model/bookingTypes'
import { BookingStep } from './BookingStep'
import { ConsentForm } from './ConsentStep/ConsentForm'
import { IncompletedStepLabel } from './IncompletedStepLabel'
import { Summary } from './Summary'

export function ConsentStep() {
  const { state, goToStep, isStepCompleted } = useBooking()
  const isCompleted = isStepCompleted(BookingStepEnum.CONSENT)

  if (state.currentStep === BookingStepEnum.CONSENT) {
    return (
      <BookingStep>
        <BookingStep.Title>
          <Trans>Consents</Trans>
        </BookingStep.Title>
        <BookingStep.Content>
          <ConsentForm />
        </BookingStep.Content>
      </BookingStep>
    )
  }

  if (isCompleted) {
    return <Summary icon="✓" label={t`Consents`} onEdit={() => goToStep(BookingStepEnum.CONSENT)} text={t`Consents accepted`} />
  }

  return (
    <IncompletedStepLabel icon="✓">
      <Trans>Consents</Trans>
    </IncompletedStepLabel>
  )
}
